import { useRating } from '@risksmart-app/components/src/hooks/useRating';

import useEntityInfo from '@/hooks/getEntityInfo';
import { useCommonLookupLazy } from '@/hooks/useCommonLookupLazy';
import { useIsFeatureVisibleToOrgLazy } from '@/utils/featureFlags';

import type { Helpers } from './update/display-types/types';

export const useCustomDatasourceHelpers = () => {
  const isFeatureVisibleToOrg = useIsFeatureVisibleToOrgLazy();
  const getEntityInfo = useEntityInfo();
  const {
    getByValueAndRatingKey: getRatingByValue,
    getOptionsByRatingKey: getRatingOptions,
  } = useRating();
  const {
    getByValue: getCommonLookupByValue,
    getOptions: getCommonLookupOptions,
  } = useCommonLookupLazy();

  const helpers: Helpers = {
    isFeatureVisibleToOrg,
    getRatingByValue,
    getCommonLookupByValue,
    getRatingOptions,
    getCommonLookupOptions,
    getEntityInfo,
  };

  return helpers;
};
